export default __webpack_public_path__ + "static/media/accept-dropdown.1155a0ff.svg";